import { mapValues, orderBy } from 'lodash';

import { TimeToSecond } from '../constants/general';
import { Grade, GRADES, STARS } from '../constants/grade';
// import { MAX_PUZZLES, PUZZLE_PIECES } from '../constants/puzzle';
import { Reward, Uuid } from '../models/Base';
import { MemberReward } from '../models/GameControllerStore';
import { RecordStoreAction } from '../models/RecordStore';

import { interpolate } from './math';
import { sumNumberRecords } from './object';

// export const getAlbumAverageScore = (
//   parts: (AlbumSummary['parts'] | undefined)[],
// ) => {
//   const accumulation = parts.reduce(
//     (acc, partSummary) => {
//       acc.totalScore +=
//         (partSummary?.overall.averageGameScore ?? 0) *
//         (partSummary?.overall.completedGameCount ?? 0);
//       acc.completedGameCount += partSummary?.overall.completedGameCount ?? 0;
//       return acc;
//     },
//     { totalScore: 0, completedGameCount: 0 },
//   );
//   if (accumulation.completedGameCount === 0) return 0;
//   return Math.round(accumulation.totalScore / accumulation.completedGameCount);
// };

/**
 * get memory index by memoryIndexStatistics
 * @param memoryIndexStatistics
 * @returns memory index text
 */
export const getMemoryIndexText = (
  memoryIndexStatistics: number[], // (number | MemoryIndexStatistics)[],
): string => {
  const gradeString = memoryIndexStatistics.reduce<string>(
    (acc, s) => acc + (typeof s === 'number' ? getGradeByScore(s) : 0), //getGradeByScore(s.total / s.count)),
    '',
  );
  return gradeString.padEnd(4, '-');
};

const getExtraReward = (answerSlots: number) => {
  switch (true) {
    case answerSlots >= 1 && answerSlots <= 6:
      return 0;
    default:
      return Math.max(answerSlots - 6, 0);
  }
};

const setZeroValuesToNil = (obj: Reward) => {
  Object.keys(obj).forEach((_key) => {
    const key = _key as keyof Reward;
    if (obj[key]) {
      const value = obj[key];
      if (typeof value === 'number' && value > 0) {
        obj[key] = value;
      } else {
        delete obj[key];
        obj[key] = undefined;
      }
    }
  });
};

export const computeReward = (
  isAtLeastMember: boolean | undefined,
  reward: Reward,
  isWinner: boolean,
  star: number,
  claimed: (Reward | undefined)[],
  multiple = 1,
  answerSlots = 0,
) => {
  if (Object.keys(reward).length === 0) {
    return {
      reward: {} as Reward,
      memberReward: {} as MemberReward,
      winnerReward: isWinner ? { exp: 10, joyPoint: 10 } : null,
    };
  }
  const classroomCredit = reward.joyPoint || 0;
  const extraReward = getExtraReward(answerSlots);

  let r = { ...reward };
  r.joyPoint = (r.joyPoint || 0) + extraReward;
  r.classroomCredit = undefined;
  if (isAtLeastMember) {
    r.classroomCredit = classroomCredit + extraReward;
  }

  r = mapValues(r, (value) => Math.max(0, (value || 0) * multiple));

  r = claimed.reduce<Reward>(
    (acc, cur) =>
      mapValues(acc, (value, _key) => {
        const key = _key as keyof Reward;
        return Math.max(0, (value || 0) - (cur?.[key] || 0)) || undefined;
      }),
    r,
  );

  r = mapValues(
    r,
    (value) => Math.max(0, Math.ceil(((value || 0) * 2 * star) / 10)), // prevent the precision error
  );

  r.exp = r.joyPoint || 0;
  setZeroValuesToNil(r);

  let memberReward = null;
  if (isAtLeastMember) {
    memberReward = {
      puzzlePieces: [],
      classroomCredit: r.classroomCredit || 0,
    };
  }

  return {
    reward: r,
    memberReward: memberReward,
    winnerReward: isWinner ? { exp: 10, joyPoint: 10 } : null,
  };
};

/**
 * compute reward for game or challenge
 */

// depracated
// export const computeReward = (
//   spaceMembership: SpaceMembership | null | undefined,
//   reward: Reward,
//   {
//     classroomCredit = reward.joyPoint ?? 0,
//     puzzlePiece = 1,
//     records = [],
//     minimum = { joyPoint: 1 },
//   }: {
//     classroomCredit?: number;
//     puzzlePiece?: number;
//     records?: { reward?: Reward }[];
//     minimum?: Reward;
//   },
//   score = 100,
//   puzzleReceived = puzzlePiece,
// ): { reward: Reward; memberReward?: MemberReward } => {
//   let r: Reward = omit(reward, ['classroomCredit', 'puzzlePiece']);

//   // only member can have classroom credit
//   if (spaceMembership?.isAtLeastMember) {
//     r.classroomCredit = classroomCredit;
//   }

//   // apply score (since server not receiving 0, convert 0 to undefined)
//   r = mapValues(
//     reward,
//     (value) =>
//       Math.max(0, Math.round(((value ?? 0) * score) / 100)) || undefined,
//   );

//   // calculate puzzle receieved
//   let puzzlePieces: number[] = [];
//   if (spaceMembership?.isAtLeastMember) {
//     puzzlePieces = Array.from({
//       length:
//         score === 0 ? 0 : Math.min(puzzlePiece, Math.max(0, puzzleReceived)),
//     }).reduce<number[]>((acc) => {
//       // const targetPiece =
//       //   spaceMembership.puzzle.collectedPieceCount + acc.length;
//       // avoid exceed the server max
//       // if (targetPiece < MAX_PUZZLES * PUZZLE_PIECES) {
//       //   acc.push(targetPiece);
//       // }
//       return acc;
//     }, []);

//     r.puzzlePiece = puzzlePieces.length || undefined;
//   }

//   // remove rewards in previous record (since server not receiving 0, convert 0 to undefined)
//   r = records.reduce(
//     (acc, cur) =>
//       mapValues(acc, (value, key) =>
//         value === undefined
//           ? undefined
//           : Math.max(0, value - (cur.reward?.[key as keyof Reward] ?? 0)) ||
//             undefined,
//       ),
//     r,
//   );

//   // apply minimum
//   const m = Object.entries(minimum) as [keyof Reward, number | undefined][];
//   m.forEach(([key, value]) => {
//     if (
//       value &&
//       (r[key] ?? 0) <= value &&
//       (!['classroomCredit', 'puzzlePiece'].includes(key) ||
//         spaceMembership?.isAtLeastMember)
//     ) {
//       r[key] = value;
//     }
//   });

//   // genereate member reward
//   let memberReward: MemberReward | undefined;
//   if (spaceMembership?.isAtLeastMember) {
//     memberReward = {
//       puzzlePieces: puzzlePieces.slice(0, r.puzzlePiece ?? 0),
//       classroomCredit: r.classroomCredit ?? 0,
//     };
//   }

//   return { reward: r, memberReward };
// };

const calculateDecimal = (score: number, min: number, max: number): number => {
  return interpolate(score, [min, max], [0, 1]);
};

export const getStarsByScore = (score = 0, withInterpolate = false): number => {
  const threshold = orderBy(STARS, 'stars', 'desc').map((star) => star.min) as [
    number,
    number,
    number,
    number,
    number,
    number,
  ];
  if (score >= threshold[0]) {
    return 5;
  } else if (score >= threshold[1]) {
    return (
      4 +
      (withInterpolate
        ? calculateDecimal(score, threshold[1], threshold[0])
        : 0)
    );
  } else if (score >= threshold[2]) {
    return (
      3 +
      (withInterpolate
        ? calculateDecimal(score, threshold[2], threshold[1])
        : 0)
    );
  } else if (score >= threshold[3]) {
    return (
      2 +
      (withInterpolate
        ? calculateDecimal(score, threshold[3], threshold[2])
        : 0)
    );
  } else if (score >= threshold[4]) {
    return (
      1 +
      (withInterpolate
        ? calculateDecimal(score, threshold[4], threshold[3])
        : 0)
    );
  }
  return 0 + (withInterpolate ? calculateDecimal(score, 0, threshold[4]) : 0);
};

export const getScoreByStars = (
  stars?: number,
): { min: number; max: number } | undefined => {
  if (stars === undefined) {
    return undefined;
  }
  const match = STARS.find(({ stars: s }) => stars === s);
  return match ? { min: match.min, max: match.max } : undefined;
};

export const getStarsByStar = (star: number) => {
  const match = STARS.find(({ stars: s }) => star === s);
  return match;
};

export const getGradeByScore = (score: number | undefined): Grade => {
  if (score === undefined) {
    return Grade.U;
  }
  return GRADES.find(({ min }) => score >= min)?.grade ?? Grade.U;
};

export const revisionPhaseToMemoryIndex = (
  phase: number,
): number | undefined => {
  switch (phase) {
    case 1:
    case 2:
    case 3:
      return 0;
    case 4:
    case 5:
    case 6:
      return 1;
    case 7:
    case 8:
    case 9:
      return 2;
    case 10:
    case 11:
    case 12:
      return 3;
  }
  return;
};

export const revisionPhaseToScheduledTime = (
  phase: number,
): number | undefined => {
  switch (phase) {
    case 1:
      return 15 * TimeToSecond.Minute * 1000;
    case 2:
      return 3 * TimeToSecond.Hour * 1000;
    case 3:
      return 6 * TimeToSecond.Hour * 1000;
    case 4:
      return TimeToSecond.Day * 1000;
    case 5:
      return 2 * TimeToSecond.Day * 1000;
    case 6:
      return 7 * TimeToSecond.Day * 1000;
    case 7:
      return 15 * TimeToSecond.Day * 1000;
    case 8:
      return 30 * TimeToSecond.Day * 1000;
    case 9:
      return 60 * TimeToSecond.Day * 1000;
    case 10:
      return 0.5 * TimeToSecond.Year * 1000;
    case 11:
      return 1 * TimeToSecond.Year * 1000;
    case 12:
      return 2 * TimeToSecond.Year * 1000;
  }
  return;
};

type IsFirstTimePlay = {
  game: (
    getGameRecords: RecordStoreAction['getGameRecords'],
    gameSetId: Uuid,
    gameId: Uuid,
  ) => boolean;
  // show: (
  //   getSlideshowRecords: RecordStoreAction['getSlideshowRecords'],
  //   gameSetId: Uuid,
  //   slideshowId: Uuid,
  // ) => boolean;
};
export const isFirstTimeGamePlay: IsFirstTimePlay['game'] = (
  getGameRecords,
  gameSetId,
  gameId,
) =>
  !(
    getGameRecords('gamePlay')?.some(
      (r) =>
        r.gameSetId === gameSetId &&
        r.gameId === gameId &&
        (r.isSlideshow || r.isNormal),
    ) ?? false
  );
// export const isFirstTimeShowView: IsFirstTimePlay['show'] = (
//   getSlideshowRecords,
//   gameSetId,
//   slideshowId,
// ) => (getSlideshowRecords(gameSetId, slideshowId)?.length ?? 0) === 0;

export type Rating = {
  pronunciation: number;
  fluency: number;
  accuracy: number;
  overall: number;
  score: number;
};

export const convertToRating = (
  index: number,
  performance?: Record<string, number>,
): Rating => {
  return {
    pronunciation: performance?.[`pronunciation_${index}`] ?? 0,
    fluency: performance?.[`fluency_${index}`] ?? 0,
    accuracy: performance?.[`accuracy_${index}`] ?? 0,
    overall: performance?.[`overall_${index}`] ?? 0,
    score: performance?.[`score_${index}`] ?? 0,
  };
};

export const calculateOverallRating = (ratings: Rating[]): Rating => {
  const length = ratings.length;
  const total = ratings.reduce<Rating>(
    (acc, cur) => sumNumberRecords(acc, cur),
    {
      pronunciation: 0,
      fluency: 0,
      accuracy: 0,
      overall: 0,
      score: 0,
    },
  );
  if (length === 0) {
    return total;
  }
  return {
    pronunciation: Math.floor(total.pronunciation / length),
    fluency: Math.floor(total.fluency / length),
    accuracy: Math.floor(total.accuracy / length),
    overall: Math.floor(total.overall / length),
    score: Math.floor(total.score / length),
  };
};
